class FooterNavigation extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll('.footer-navigation__accordion').forEach((accordion) => {
      accordion.addEventListener('click', this.toggleAccordion.bind(this));
    });
  }

  toggleAccordion(event) {
    const accordion = event.target;
    const list = accordion.closest('.footer-navigation__nav');
    list.classList.toggle('is--open');
  }
}

customElements.define('footer-navigation', FooterNavigation);